"use client";

import { Play } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
export default function Hero() {
  return <section data-section-id="515" id="eccellenza-nella-bonifica-tecnica" className="relative min-h-screen w-full overflow-hidden bg-[var(--color-foreground)] dark bg-background text-foreground border-b border-white/10 shadow-inner">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/industrial_hvac_ductwork_installation.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/industrial_hvac_ductwork_installation.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/industrial_hvac_ductwork_installation.png-wvc-sizes" alt="Impianto HVAC industriale - bonifica tecnica e manutenzione specialistica" loading="eager" decoding="async" className="h-full w-full object-cover animate-[kenburns_20s_ease-in-out_infinite_alternate]" />
        
        {}
        <div className="absolute top-1/4 right-[15%] z-10 opacity-20 mix-blend-overlay hidden lg:block">
          <WvcLogo className="h-12 w-auto grayscale brightness-200" />
        </div>
      </div>

      {}
      <div className="absolute inset-0 z-10" style={{
      background: "linear-gradient(to bottom, hsla(222, 47%, 7%, 0.85) 0%, hsla(222, 47%, 7%, 0.5) 45%, hsla(222, 47%, 7%, 0.95) 100%)"
    }} />

      {}
      <div className="relative z-20 mx-auto flex min-h-screen w-full max-w-7xl flex-col px-6 pt-32 pb-24 md:px-10 lg:px-16">
        {}
        <div className="flex flex-1 items-center">
          <div className="max-w-3xl">
            {}
            <div className="mb-8 flex items-center gap-4">
              <span className="h-px w-12" style={{
              backgroundColor: "hsl(174, 100%, 33%)"
            }} />
              <span className="font-mono text-xs tracking-[0.25em] uppercase" style={{
              color: "var(--color-primary)"
            }}>
                Aera &middot; Divisione Tecnica
              </span>
            </div>

            {}
            <h1 className="font-default font-semibold leading-[0.95] tracking-tight" style={{
            color: "var(--color-secondary)",
            fontSize: "clamp(3.5rem, 10vw, 8rem)"
          }}>
              Bonifica tecnica della{" "}
              <em className="italic font-normal" style={{
              color: "var(--color-primary)"
            }}>
                qualità dell'aria.
              </em>
            </h1>

            {}
            <p className="mt-8 max-w-2xl font-default text-lg leading-relaxed md:text-xl" style={{
            color: "hsla(0, 0%, 100%, 0.85)"
          }}>
              Riqualificazione igienico-funzionale di sistemi HVAC attraverso metodologie certificate. Garantiamo l'efficienza degli impianti con interventi programmati, ispezioni video robotizzate e report fotografici analitici per la massima sicurezza ambientale.
            </p>

            {}
            <div className="mt-12 flex flex-col gap-4 sm:flex-row sm:items-center">
              <Button asChild size="lg" className="rounded-lg bg-[var(--color-primary)] px-8 py-6 text-base font-medium text-white shadow-lg hover:bg-[var(--color-primary)]/90">
                <Link to="/TechnicalInspectionPage">Richiedi sopralluogo tecnico &rarr;</Link>
              </Button>

              <Button asChild size="lg" className="rounded-lg bg-[var(--color-primary)] px-8 py-6 text-base font-medium text-white shadow-lg hover:bg-[var(--color-primary)]/90">
                <Link to="/TechnicalDivisionPage">
                  <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-white/20">
                    <Play className="h-3 w-3 fill-current" />
                  </span>
                  Scopri le soluzioni
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="relative mt-auto flex items-end justify-between pt-12">
          {}
          <div className="flex flex-col items-center gap-3">
            <span className="font-mono text-[10px] tracking-[0.4em] uppercase" style={{
            color: "hsla(0, 0%, 100%, 0.7)",
            writingMode: "vertical-rl",
            transform: "rotate(180deg)"
          }}>
              Scroll
            </span>
            <div className="relative h-16 w-px overflow-hidden">
              <div className="absolute inset-0 animate-[scrollLine_2s_ease-in-out_infinite]" style={{
              backgroundColor: "hsla(174, 100%, 33%, 0.6)"
            }} />
            </div>
          </div>

          {}
          <div className="hidden md:block">
            <span className="font-mono text-xs tracking-wider" style={{
            color: "hsla(0, 0%, 100%, 0.7)"
          }}>
              HVAC &middot; UTA &middot; FILTRI &middot; VENTILATORI
            </span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes kenburns {
          0% {
            transform: scale(1) translate(0, 0);
          }
          100% {
            transform: scale(1.12) translate(-1%, -1%);
          }
        }
        @keyframes scrollLine {
          0% {
            transform: translateY(-100%);
          }
          100% {
            transform: translateY(100%);
          }
        }
      `}</style>
    </section>;
}